import React from 'react'
import { Text } from 'theme-ui'

import {
  FeatureStyled,
  FeatureMediaStyled,
  FeatureContentStyled,
  FeatureContentHeadStyled,
  FeatureContentBodyStyled,
  FeatureContentFooterStyled
} from './styles'
import Button from './../../atoms/Button'

import { FeatureProps } from './types'
import MediaItem from './../../molecules/MediaItem'

const Feature: React.FC<FeatureProps> = ({ data }) => {
  const { media, title, description, cta } = data

  return (
    <FeatureStyled>
      {media.image || media.video ? (
        <FeatureMediaStyled>
          <MediaItem {...{ media }} />
        </FeatureMediaStyled>
      ) : (
        ''
      )}
      <FeatureContentStyled>
        <FeatureContentHeadStyled>
          <Text
            sx={{
              variant: 'headingRaleway2',
              fontFamily: 'secondary',
              fontWeight: 'bold'
            }}
          >
            {title}
          </Text>
        </FeatureContentHeadStyled>
        {description && (
          <FeatureContentBodyStyled>
            <Text
              sx={{
                variant: 'bodyMontserrat6',
                fontFamily: 'primary'
              }}
            >
              {description}
            </Text>
          </FeatureContentBodyStyled>
        )}
        {cta && (
          <FeatureContentFooterStyled>
            <Button variant="withArrow" {...cta} />
          </FeatureContentFooterStyled>
        )}
      </FeatureContentStyled>
    </FeatureStyled>
  )
}

export default Feature
